export const KNOWN_INFUSION_MAPPING_CREATE = 'serviceData.KNOWN_INFUSION_MAPPING_CREATE';
export const KNOWN_INFUSION_MAPPING_DESTROY = 'serviceData.KNOWN_INFUSION_MAPPING_DESTROY';
export const KNOWN_INFUSION_MAPPING_ADD = 'serviceData.KNOWN_INFUSION_MAPPING_ADD';
export const KNOWN_INFUSION_MAPPING_ADD_COMMIT = 'serviceData.KNOWN_INFUSION_MAPPING_ADD_COMMIT';
export const KNOWN_INFUSION_MAPPING_SET = 'serviceData.KNOWN_INFUSION_MAPPING_SET';
export const KNOWN_INFUSION_MAPPING_SET_COMMIT = 'serviceData.KNOWN_INFUSION_MAPPING_SET_COMMIT';
export const KNOWN_INFUSION_MAPPING_REMOVE = 'serviceData.KNOWN_INFUSION_MAPPING_REMOVE';
export const KNOWN_INFUSION_MAPPING_REMOVE_COMMIT = 'serviceData.KNOWN_INFUSION_MAPPING_REMOVE_COMMIT';
